import Subtitle from '@/components/Subtitles/Subtitle'
import useAudioSubtitle from '@/composables/useAudioSubtitles'

export default function AudioEngine() {
  const { current } = useAudioSubtitle()

  return (
    current && (
      <div
        key={current.start}
        className='AudioSubtitleWrapper fixed bottom-0 left-0 w-full px-20 md:px-[20vw] z-999 flex items-center justify-center pointer-events-none pb-72 md:pb-20'
      >
        <div className='relative min-h-80 flex items-center pointer-events-auto'>
          <Subtitle text={current.text} />
        </div>
      </div>
    )
  )
}
